import { Component } from '@angular/core';

@Component({
    selector: 'bb-iban-pipe-page-ui',
    templateUrl: './bb-iban-page-ui.component.html',
    standalone: false,
})
export class IbanPageComponent {}
